import ErrorReducer from './error/ErrorReducer';
import UserReducer from './user/UserReducer';
import FilterReducer from './filters/FilterReducer'
import { combineReducers } from 'redux';
import LanguageReduceurs from './language/LanguageReduceurs';

const marketPayReduceur = combineReducers({
    errorState: ErrorReducer,
    userState: UserReducer,
    filterState: FilterReducer,
    languageState: LanguageReduceurs
});

export default marketPayReduceur;



// WEBPACK FOOTER //
// ./src/store/reduceurs.js